module.exports = __webpack_public_path__ + "img/pay-on.76363b08.svg";